import { optionTextDefault } from "../../../common-strings.util";
import { getSupportedAudioCodecs } from "../../../../modules/multiplayer/mediaStream/Utils";
import i18next from "i18next";
export function getAudioCodecOptions() {
    const supportedAudioCodecs = getSupportedAudioCodecs();
    const audioCodecs = [];
    audioCodecs.push({ value: "", label: optionTextDefault() });
    audioCodecs.push(...supportedAudioCodecs.map((codec) => {
        const name = `${codec.mimeType} ${codec.channels || ""} ${codec.clockRate} ${codec.sdpFmtpLine || ""}`.trim();
        return { value: name, label: name };
    }));
    return audioCodecs;
}
export function getBandwidthOptions() {
    return [
        { value: "", label: i18next.t("settings:dev-bandwidth-option-unlimited", "Unlimited") },
        { value: "2000", label: "2000" },
        { value: "1000", label: "1000" },
        { value: "500", label: "500" },
        { value: "250", label: "250" },
        { value: "125", label: "125" },
        { value: "75", label: "75" },
        { value: "56", label: "56" },
        { value: "48", label: "48" },
        { value: "32", label: "32" },
        { value: "28", label: "28" },
        { value: "24", label: "24" },
        { value: "16", label: "16" },
        { value: "8", label: "8" }
    ];
}
export function getAudioPriorityOptions() {
    return [
        { value: "", label: optionTextDefault() },
        { value: "very-low", label: i18next.t("settings:dev-audio-prio-option-very-low", "Very low") },
        { value: "low", label: i18next.t("settings:dev-audio-prio-option-low", "Low") },
        { value: "medium", label: i18next.t("settings:dev-audio-prio-option-medium", "Medium") },
        { value: "high", label: i18next.t("settings:dev-audio-prio-option-high", "High") }
    ];
}
export function getAudioMaxFramerateOptions() {
    return [
        { value: "", label: optionTextDefault() },
        { value: "60", label: "60" },
        { value: "50", label: "50" },
        { value: "40", label: "40" },
        { value: "30", label: "30" },
        { value: "20", label: "20" },
        { value: "15", label: "15" },
        { value: "10", label: "10" },
        { value: "5", label: "5" },
        { value: "1", label: "1" }
    ];
}
export function getAudioDistanceOptions() {
    return [
        { value: "linear", label: i18next.t("settings:dev-audio-distance-option-linear", "Linear") },
        { value: "inverse", label: i18next.t("settings:dev-audio-distance-option-inverse", "Inverse") },
        { value: "exponential", label: i18next.t("settings:dev-audio-distance-option-expo", "Exponential") }
    ];
}
export function getHtmlRendererOptions() {
    return [
        { value: "fast", label: i18next.t("settings:dev-html-render-option-fast", "Fast") },
        { value: "html2Canvas", label: i18next.t("settings:dev-html-render-option-html2canvas", "Html2Canvas") },
        { value: "html2CanvasSvg", label: i18next.t("settings:dev-html-render-option-html2canvas-svg", "Html2Canvas SVG") }
    ];
}
export function getShadowMapOptions() {
    return [
        { value: "0", label: i18next.t("settings:dev-html-shadowmap-option-basic", "Basic shadow map") },
        { value: "1", label: i18next.t("settings:dev-html-shadowmap-option-pcf", "PCF shadow map") },
        { value: "2", label: i18next.t("settings:dev-html-shadowmap-option-vsm", "VSM shadow map") },
        { value: "3", label: i18next.t("settings:dev-html-shadowmap-option-off", "Off") }
    ];
}
